import * as React from "react";
import { useTranslation } from "react-i18next";
import { useGetAsset } from "security-app/hooks/useAssetsAPI";
const LoadAssetLabel = ({ assetId }) => {
  var _a;
  const { t } = useTranslation("enterprise_security_events");
  const { asset, loadingAsset } = useGetAsset(assetId);
  if (loadingAsset) {
    return /* @__PURE__ */ React.createElement("span", null, assetId);
  }
  if (!asset) {
    return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("i", null, t("associated_asset_label.none")));
  }
  return /* @__PURE__ */ React.createElement("span", null, (_a = asset == null ? void 0 : asset.name) != null ? _a : assetId);
};
const AssociatedAssetLabel = ({ assetId }) => {
  const { t } = useTranslation("enterprise_security_events");
  if (assetId === null || assetId === "null") {
    return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("i", null, t("associated_asset_label.none")));
  }
  return LoadAssetLabel({ assetId });
};
export default AssociatedAssetLabel;
